import React from 'react';
import Button from './Button';
import classes from './Promotions.module.css';
const Promotions = props => {
    return (
        <section className={`${classes['promotions-area-bg']} section-padding`}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                            <div className="area-title text-center mt-5">
                                <h2>Special Package</h2>
                            </div>
                        </div>
                    </div>
                    <div id="carouselExampleIndicators2" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
    <div className="row" id={classes.diff}>
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-5">
                            <div className={classes["promotions-img"]}>
                                <img src="https://quomodosoft.com/html/dawat/demo/img/promotions/promo_slide_1.jpg" alt="" />
                            </div>
                            <div className={classes["promotions-details"]}>
                                <h3>40% off for 9'' - 12'' pizza - Wed, Thu, Friday only</h3>
                                <p>Pizza 12 inch + 1 Side Dish + 1,5L Coke Bottle Only From 209,000</p>
                                <div className={classes.reserbutton}><Button content="Add To Cart" /></div>
                                <br />

                            </div>
                        </div>
                    </div>
    </div>
    <div className="carousel-item">
    <div className="row" id={classes.diff}>
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-5">
                            <div className={classes["promotions-img"]}>
                                <img src="https://quomodosoft.com/html/dawat/demo/img/promotions/promo_slide_1.jpg" alt="" />
                            </div>
                            <div className={classes["promotions-details"]}>
                                <h3>40% off for 9'' - 12'' pizza - Wed, Thu, Friday only</h3>
                                <p>Pizza 12 inch + 1 Side Dish + 1,5L Coke Bottle Only From 209,000</p>
                                <div className={classes.reserbutton}><Button content="Add To Cart" /></div>
                                <br />

                            </div>
                        </div>
                    </div>
    </div>
    <div className="carousel-item">
    <div className="row" id={classes.diff}>
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-5">
                            <div className={classes["promotions-img"]}>
                                <img src="https://quomodosoft.com/html/dawat/demo/img/promotions/promo_slide_1.jpg" alt="" />
                            </div>
                            <div className={classes["promotions-details"]}>
                                <h3>40% off for 9'' - 12'' pizza - Wed, Thu, Friday only</h3>
                                <p>Pizza 12 inch + 1 Side Dish + 1,5L Coke Bottle Only From 209,000</p>
                                <div className={classes.reserbutton}><Button content="Add To Cart" /></div>
                                <br />

                            </div>
                        </div>
                    </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
                    {/* <div className="row" id={classes.diff}>
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-5">
                            <div className={classes["promotions-img"]}>
                                <img src="https://quomodosoft.com/html/dawat/demo/img/promotions/promo_slide_1.jpg" alt="" />
                            </div>
                            <div className={classes["promotions-details"]}>
                                <h3>40% off for 9'' - 12'' pizza - Wed, Thu, Friday only</h3>
                                <p>Pizza 12 inch + 1 Side Dish + 1,5L Coke Bottle Only From 209,000</p>
                                <div className={classes.reserbutton}><Button content="Add To Cart" /></div>
                                <br />

                            </div>
                        </div>
                    </div> */}
                

            </div>
            
        </section>
    )
}
export default Promotions;